import { ModelResource } from './resource';
import { InventoryItem } from '../models';

export class InventoryItems extends ModelResource<InventoryItem> {
  model = InventoryItem;

  resourcePath = 'v1/deductions/items';
}
